import React, { forwardRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import * as icons from 'react-bootstrap-icons';
import CButton from 'Utils/Helpers/CButton';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { useDispatch } from 'react-redux';
import { useSetState } from 'Utils/Helpers/Hooks';
import Inputer from 'Utils/Helpers/Inputer';
import { enqueueSnackbar } from 'notistack';
import { updatePosbank } from 'http/components/SettingService';
import { setPosBanks } from '../../../../../Redux/slices/globalSlice';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function EditPos({ id, title }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [controls, setControls] = useSetState ({
    name: {
      id: "name",
      type: 'text',
      placeholder: 'عنوان',
      value: '',
      icon: <icons.Type/>,
    },
  });

  const onEnter = () => {
    setControls({ name: { value: title } });
  }
  const setControlsValue = (name, value) => {
    setControls({ [name]: { value: value } });
  }
  const setShowDialog = () => {
    setShow(true);
  }
  const handleClose= () => {
    setShow(false);
  }

  const onFinish = async () => {
    dispatch(HandleLoading(true));
    const { name } = controls;
    if(name.value && name.value !== '') {
      const response = await updatePosbank(id, name.value);
      if(response.status) {
        await dispatch(setPosBanks(response.data.bank));
        setShow(false);
      } 
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar('اطلاعات به درستی وارد نشده است', {variant: 'error'});
      dispatch(HandleLoading(false));
    }
  }

  return (
    <>
        <div className='edit' onClick={setShowDialog}>
          <icons.Pencil size={16}/>
        </div>
        {
          show &&
          <Dialog
            open={show}
            TransitionComponent={Transition}
            keepMounted
            fullWidth={true}
            maxWidth={'xs'}
            onClose={handleClose}
            TransitionProps={{onEnter: onEnter}}
            aria-describedby="alert-dialog-slide-pos-edit"
          >
            <DialogTitle className='edit-mode'>
              {'ویرایش دستگاه کارت‌خوان'}
              <div className='close-btn' onClick={handleClose}>
                  <icons.X/>
              </div>
            </DialogTitle>
            <DialogContent>
              { 
                show &&
                <DialogContentText id="alert-dialog-slide-pos-edit">
                  {
                    Object.keys(controls).map((key, index) => {
                      return (
                        <>
                          <small className='pe-1 mb-1'>{controls[key].placeholder}</small>
                          <Inputer
                            key={`inputer_edit_${controls[key].id}`}
                            id={controls[key].id}
                            type={controls[key].type}
                            value={controls[key].value}
                            setValue={setControlsValue.bind(this)}
                            icon={controls[key].icon}
                            className={'mb-1'}
                            onKeyEnterActive
                            onKeyEnter={onFinish}
                          />
                        </>
                      )
                    })
                  }
                </DialogContentText>
              }
            </DialogContent>
            <DialogActions>
              <CButton
                text={'ویرایش دستگاه کارت‌خوان'}
                icon={<icons.Pencil/>}
                onClick={onFinish}
              />
            </DialogActions>
          </Dialog>
        }
      </>
  );
}
